import React, {Component} from "react";
import { formatDate } from "../utils/tools"
import { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';

class RangeSlider extends Component {
  
  // ############################ CONSTRUCTOR ###################################
  // ############################ CONSTRUCTOR ###################################
  constructor(props) {
    super(props);
    this.marks = {};
    let dNow = Date.now();
    let dStart = dNow + 1000 * 3600 * 24 * -1;
    let dEnd2 = dNow + 1000 * 3600 * 24 *4;
    let dEnd = dNow + 1000 * 3600 * 24 * 4;
    for(let i=-1;i<=4;i++){
      let temp = {style: {color: 'black', fontFamily: 'FuturaM'}, label: new Date(dNow + 1000 * 3600 * 24 * i).getDate()};
      
      if( i === -1){
        temp = {
          style: {
            fontFamily: 'FuturaM', 
            fontSize: 9, 
            borderRadius:'2px', 
            backgroundColor: '#f1d6db', color: '#000000', padding: '0px 2px'}, 
          label: 'Live'}}
      if( i >= 0){temp = {style: {color: 'black', fontFamily: 'FuturaM'}, label: formatDate(new Date(dNow + 1000 * 3600 * 24 * i), 'day ddL')};}
      this.marks[dNow + 1000 * 3600 * 24 * i] = temp;
    }
    this.state = { range: [dStart, dEnd2], default:[dStart, dStart], min: dStart, max: dEnd, marks: this.marks };
  }

  // ############################ HANDLE CHANGES ###################################
  // ############################ HANDLE CHANGES ###################################
  handleChange = (e) => {

    // console.log('#### RANGECHANGE 1 => ', e)
    let tLive =  new Date();
    tLive.setHours(0,1)
    let t0 =  new Date(e[0]);
    t0.setHours(0,1)
    let t1 =  new Date(e[1]);
    t1.setHours(23,32)

    // console.log('#### RANGECHANGE 2 => ', t0.toString(), ', ', t1.toString());

    let res = [
      (this.marks[e[0]]['label'] === 'Live' ? 
        tLive.toUTCString() : 
        t0.toUTCString()
      ), 
      (this.marks[e[1]]['label'] === 'Live'? 
        'Live' : 
        t1.toUTCString()
      )
    ];    
    this.props.onSlider(res);
  }

  
  render() {
    return (
        <div className={"geo-range-shell"}>
            <Range 
                className="geo-range-slider"
                draggableTrack
                defaultValue={this.state.default}
                value={this.state.range}
                onChange={(e) => {
                  this.setState({range: e})
                }}
                onAfterChange={(e) => {
                  this.handleChange(e)
                }}
                min={this.state.min}
                max={this.state.max}
                dots={true}
                step={1000 * 3600 * 24}
                marks={this.state.marks}
                trackStyle={[{ background: 'linear-gradient(90deg, #7f1022 0%, #ad182f 100%)', height: 6, borderRadius: 999 }]}
                railStyle={{ backgroundColor: '#edd8dc', height: 6, borderRadius: 999 }}
                handleStyle={[
                  { backgroundColor: '#ffffff', borderColor: '#ad182f', borderWidth: 3, width: 16, height: 16, marginTop: -5, boxShadow: '0 4px 10px rgba(58, 10, 18, 0.22)' },
                  { backgroundColor: '#ffffff', borderColor: '#ad182f', borderWidth: 3, width: 16, height: 16, marginTop: -5, boxShadow: '0 4px 10px rgba(58, 10, 18, 0.22)' }
                ]}
                activeDotStyle={{
                  backgroundColor: '#ad182f',
                  borderColor: '#ad182f',
                  width: 5,
                  height: 5,
                  borderRadius: 999,
                  marginLeft: 0,
                  bottom: 1.5
                }}
                dotStyle={{
                  backgroundColor: '#ccb8bc',
                  borderColor: '#ccb8bc',
                  width: 5,
                  height: 5,
                  borderRadius: 999,
                  marginLeft: 0,
                  bottom: 1.5
                }}
            />
        </div>
    );
  }
}
export default RangeSlider;

